import React from "react";
import styled from "styled-components";
import {AiTwotoneHeart} from 'react-icons/ai'
import { CONTAINER } from "../about/About";
import { COLOR1, TEXT_TITLE_COLOR } from "../global";

export const Footer = () => {
  return (
    <FOOTER>
      <ul>
        <li>
          {" "}
          <a href="#">Home</a>{" "}
        </li>
        <li>
          {" "}
          <a href="#about">About</a>{" "}
        </li>
        <li>
          {" "}
          <a href="#skills">Skills</a>{" "}
        </li>
        <li>
          {" "}
          <a href="#portfolio">Portfolio</a>{" "}
        </li>
        <li>
          {" "}
          <a href="#contact">Contact</a>{" "}
        </li>
      </ul>

      <div>
        Made with <AiTwotoneHeart/> by Mitresh Prajapati.
      </div>
    </FOOTER>
  );
};

const FOOTER = styled.div`
  width: 100%;
  min-height: 15rem;
  margin: auto;
  margin-bottom: 0;
  background-color: ${COLOR1};
  ul{
    width: 100%;
    display: flex;
    gap: 1rem ;
    justify-content: center;
    padding: 2rem 0;
    li{
      a{
        text-decoration: none;
        color: white;
      }

    }
    @media screen and (min-width: 300px) and (max-width: 400px){
      width: 90%;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
     }
  }

  div{
    color: white;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
  }
`;
